import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = { reorderUrl: String }

  connect() {
    const tbody = document.getElementById("menu-items-sortable")
    if (!tbody) return

    this.sortable = Sortable.create(tbody, {
      handle: "[data-drag-handle]",
      animation: 150,
      onEnd: () => this.saveOrder()
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  saveOrder() {
    const rows = document.querySelectorAll("#menu-items-sortable tr[data-id]")
    const ids = Array.from(rows).map(r => r.dataset.id)
    fetch(this.reorderUrlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
      },
      body: JSON.stringify({ ids })
    })
  }
}
